import { useMatchingFailContext } from '@context/MatchingFail';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import ButtonContainer from './components/ButtonContainer';
import ContentContainer from './components/ContentContainer';

import * as styles from './styles';

const MatchingFailView = () => {
  const { setButtonFocus } = useMatchingFailContext();
  const { ref, focusKey } = useFocusable();

  useEffect(() => {
    setButtonFocus();
  }, [setButtonFocus]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container} ref={ref}>
        <div css={styles.backgroundImage} />
        <ContentContainer />
        <ButtonContainer />
      </div>
    </FocusContext.Provider>
  );
};

export default MatchingFailView;
